import { useEffect } from "react";

export default function FilterComponent({
  openFilter,
  setOpenFilter,
  selectedItems,
  setSelectedItems,
  labelKey,
  title,
}: {
  openFilter: boolean;
  setOpenFilter: any;
  selectedItems: any[];
  setSelectedItems: any;
  labelKey: string; // e.g., "clusterDDN" or "DDNNumber"
  title: string; // e.g., "Clusters" or "TSPs"
}) {
  const handleClick = (e: any) => {
    const { name, checked } = e.target;

    // Select All
    if (name === "All Select") {
      const tempList = selectedItems.map((item) => ({
        ...item,
        isChecked: checked,
      }));
      setSelectedItems(tempList);
    } else {
      // Individual Item
      const tempList = selectedItems.map((item) =>
        item[labelKey] === name ? { ...item, isChecked: checked } : item
      );
      setSelectedItems(tempList);
    }
  };

  const handleDone = () => {
    setOpenFilter(false);
  };

  return (
    <div className="fixed inset-0 z-10 overflow-y-auto">
      <div
        className="fixed inset-0 w-full h-full bg-black opacity-40"
        onClick={() => setOpenFilter(false)}
      ></div>
      <div className="flex items-center min-h-screen px-4 py-8">
        <div className="relative w-full max-w-4xl p-4 mx-auto bg-white rounded-lg shadow-lg">
          <div className="mt-3 sm:flex">
            <div className="mb-2 text-center sm:ml-4 sm:text-left">
              <h4 className="text-lg font-medium text-gray mb-4">
                Select {title} , {labelKey} to map with this vehicle.
              </h4>

              <div className="grid grid-cols-3 gap-2">
                {selectedItems.map((item) => (
                  <div
                    key={item[labelKey]}
                    className="border rounded border-borderColor p-2"
                  >
                    <input
                      type="checkbox"
                      name={item[labelKey]}
                      defaultChecked={item?.isChecked}
                      className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray"
                      onClick={handleClick}
                    />
                    <label className="ml-2 capitalize text-sm font-sans font-light">
                      {item[labelKey]}
                    </label>
                  </div>
                ))}
              </div>

              <div className="items-center gap-3 mt-3 sm:flex">
                <button
                  className="w-full bg-lightBlue text-Black font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg"
                  type="button"
                  onClick={() => setOpenFilter(false)}
                >
                  Cancel
                </button>
                <button
                  className="w-full bg-recity text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg"
                  type="button"
                  onClick={handleDone}
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
